import { FC } from 'react'
import { AssetSource } from 'models'
import { getIntegrationLogo } from 'lib/utils'
import OnyxiaTooltip from 'ui/components/tooltip/OnyxiaTooltip'
import { LogoRow } from './assetDetailsPane.styles'
import { sourceLabel } from '../utils/assetSources'

/* The column fits four 24px slots; a fifth source turns the last one into a count. */
const MAX_LOGOS = 4

interface Props {
  sources: AssetSource[]
  inline?: boolean
}

/* The instances that reported one value — the evidence behind the merge, shown beside it. */
const AttributeSources: FC<Props> = ({ sources, inline }) => {
  if (!sources.length) return null

  const overflow = sources.length > MAX_LOGOS ? sources.length - (MAX_LOGOS - 1) : 0
  const visible = overflow ? sources.slice(0, MAX_LOGOS - 1) : sources

  return (
    <LogoRow className={inline ? 'is-inline' : ''}>
      {visible.map((source) => (
        <OnyxiaTooltip key={source.instance} title={sourceLabel(source)} placement="top">
          <img src={getIntegrationLogo(source.product, 'circle')} alt="" />
        </OnyxiaTooltip>
      ))}
      {!!overflow && (
        <OnyxiaTooltip title={sources.slice(MAX_LOGOS - 1).map(sourceLabel).join(', ')} placement="top">
          <span className="logo-overflow">+{overflow}</span>
        </OnyxiaTooltip>
      )}
    </LogoRow>
  )
}

export default AttributeSources
